import { useSWR } from "../helpers";

export const useDropboxAuthCheck = () => useSWR<boolean>(`/dropbox/auth/check`);
